import { DocumentAddItemsType } from '@/api/product/model/documentAddModel'
import type { Mutation } from 'vuex'
import actionTypes from './actionTypes'
import { State } from './state'

const mutations: { [actionTypes: string]: Mutation<State> } = {
    //ドキュメント新規登録 Modal status
    [actionTypes.SET_MODAL_DOCUMENT_ADD_ACTIVE_STATUS]: (
        state: State,
        status: boolean
    ): void => {
        state.modalDocumentAddActived = status
    },

    //キャンセル Modal status
    [actionTypes.SET_MODAL_DOCUMENT_ADD_CANCEL_ACTIVE_STATUS]: (
        state: State,
        status: boolean
    ): void => {
        state.modalDocumentAddCancelActived = status
    },

    //登録 Modal status
    [actionTypes.SET_MODAL_DOCUMENT_ADD_SUBMIT_ACTIVE_STATUS]: (
        state: State,
        status: boolean
    ): void => {
        state.modalDocumentAddSubmitActived = status
    },

    //ドキュメント新規登録 画面データ
    [actionTypes.SET_DOCUMENT_ADD_ITEMS]: (
        state: State,
        list: DocumentAddItemsType,
    ): void => {
        state.documentAddItems = { ...list }
    },

    //ドキュメント新規登録 備考チェック
    [actionTypes.SET_REMARK_CHECK_ERROR]: (
        state: State,
        errorMessage: string
    ): void => {
        state.remarkCheckError = errorMessage
    },

    //ドキュメント新規登録　チェックエラー
    [actionTypes.SET_HAS_ERR]: (state: State, status: boolean): void => {
        state.hasErr = status
    },

    //ドキュメント新規登録　登録成功フラグ
    [actionTypes.SET_ADD_OK]: (state: State, status: boolean): void => {
        state.addOk = status
    },

    //ドキュメントデータ
    [actionTypes.SET_DOCUMENT_DATAS]: (
        state: State,
        list: Array<any>,
    ): void => {
        state.documentDatas = [...list]
    },
}

export default mutations
